export function StarRisingIcon(props: JSX.IntrinsicElements['svg']) {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        d="M14.8999 4.83262C15.2462 3.72246 16.7539 3.72246 17.1002 4.83262L17.818 7.13393C17.9729 7.63041 18.417 7.96655 18.9182 7.96655H21.2411C22.3617 7.96655 22.8276 9.46027 21.921 10.1464L20.0417 11.5687C19.6363 11.8755 19.4667 12.4194 19.6215 12.9159L20.3393 15.2172C20.6856 16.3274 19.4658 17.2505 18.5593 16.5644L16.68 15.1421C16.2746 14.8353 15.7256 14.8353 15.3201 15.1421L13.4409 16.5644C12.5343 17.2505 11.3145 16.3274 11.6608 15.2172L12.3786 12.9159C12.5335 12.4194 12.3638 11.8755 11.9584 11.5687L10.0791 10.1464C9.17255 9.46027 9.63847 7.96655 10.759 7.96655H13.082C13.5831 7.96655 14.0272 7.63041 14.1821 7.13393L14.8999 4.83262Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.2634 18.9267C20.8562 18.6303 21.577 18.8706 21.8734 19.4633L25.0734 25.8633C25.3698 26.4561 25.1295 27.1769 24.5367 27.4733C23.944 27.7697 23.2231 27.5294 22.9268 26.9367L19.7268 20.5367C19.4304 19.9439 19.6706 19.2231 20.2634 18.9267Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.7367 18.9267C11.144 18.6303 10.4231 18.8706 10.1268 19.4633L6.92675 25.8633C6.63037 26.4561 6.87064 27.1769 7.46341 27.4733C8.05619 27.7697 8.77699 27.5294 9.07338 26.9367L12.2734 20.5367C12.5698 19.9439 12.3295 19.2231 11.7367 18.9267Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.0001 18.8C16.6628 18.8 17.2001 19.3373 17.2001 20V27.2C17.2001 27.8627 16.6628 28.4 16.0001 28.4C15.3373 28.4 14.8001 27.8627 14.8001 27.2V20C14.8001 19.3373 15.3373 18.8 16.0001 18.8Z"
        fill="currentColor"
      />
    </svg>
  )
}
